export default __webpack_public_path__ + "static/media/logo.5c2a8071.png";